import { createFileRoute } from '@tanstack/react-router';
import { UserProfileContent } from './p.$id';

export const Route = createFileRoute('/p/$id/$page')({
  component: UserProfilePageRoute,
});

function parsePageParam(rawPage: string | undefined): number {
  const parsed = Number(rawPage);
  if (!Number.isFinite(parsed) || parsed < 1) return 1;
  return Math.floor(parsed);
}

function UserProfilePageRoute() {
  const { id: userId, page: pageParam } = Route.useParams();
  const page = parsePageParam(pageParam);
  return <UserProfileContent userId={userId} page={page} />;
}
